import React, { Suspense, useCallback, useContext, useEffect, useState } from "react";
import SnackbarAPICall from "../../../../../shared/snackbar/SnackbarAPICall";
import { Chip } from "@material-ui/core";
import { UIContext } from "../../../../../../contexts";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../constants/caption/dashboardHeader";

import { DynamicForm } from "../../../../../../@types/dynamicForm.types";
import { Validation } from "../../../../../../@types/validation.types";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import PremiumRecalculationForm from "../../../dynamicPremiumRecalculationForm/PremiumRecalculationForm";
import { useLocation } from "react-router-dom";
import useRouteParam from "../../../../../../hooks/useRouteParam";
import { api } from "../../../../../../utils/api";
import { dateTimeZoneConverter } from "../../../../../../utils/commonFunctions/date";

const chipMessage = "This is the Premium Recalculation for GLTD Plan.";

const GLTDPremiumRecalculationForm = () => {
	const { dashboardHeader, setDashboardHeader } = useContext(UIContext);
	const [premiumRecalcDynamicForm, setPremiumRecalDynamicForm] = useState<DynamicForm>();
	const currentYear = new Date().getFullYear();
	const [isValuesFetched, setIsValuesFetched] = useState<boolean>(false);
	const currentDate = new Date();
	const queryGroupNumber = useRouteParam("gn");
	const [premiumRecalFieldsDetails, setPremiumRecalDetails] = useState<any>({
		plan_type: "CORE",
		plan_name: "",
		plan_code: "",
		current_year: currentYear,
		current_month: "",
		// recalculation_trigger: "",
		last_recalculated_by: "",
		last_recalculated_on: currentDate
	});
	const [validation, setValidation] = useState<Validation>({
		reportFieldDetails: {},
		status: "invalid"
	});

	// console.log("GGN--->Value-Check------->", queryGroupNumber);

	const handleChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { name, value } = event.target;

			setPremiumRecalDetails(Object.assign({}, premiumRecalFieldsDetails, { [name]: value }));
		},
		[premiumRecalFieldsDetails]
	);

	// const location = useLocation();
	// const searchParams = new URLSearchParams(location.search);
	// const groupNumber = searchParams.get("gn");
	// console.log("Dubgiing nunber---->", queryGroupNumber);
	const handleGetInitialFormDetails = useCallback(
		async (_queryGroupNumber: string | number) => {
			const filter = {
				plan_name: "Group Long Term Disability(Class 2)",
				group_number: Number(_queryGroupNumber)
			};

			// console.log("Cheking the filter----->>>", filter);
			try {
				const response = await api.premiumRecalculation.getPremiumRecalculation(filter);
				if (response) {
					const { plan_name, plan_code, last_recalculated_by } = response;
					setPremiumRecalDetails({
						plan_type: "CORE",
						plan_name: plan_name,
						plan_code: plan_code,
						current_year: currentYear,
						last_recalculated_by: last_recalculated_by || "N/A",
						last_recalculated_on: dateTimeZoneConverter(currentDate as unknown as string)
					});
					setIsValuesFetched(true);
				}
			} catch (error) {
				console.error("Error fetching premium recalculation:", error);
			}
		},
		[queryGroupNumber]
	);

	useEffect(() => {
		queryGroupNumber && handleGetInitialFormDetails(queryGroupNumber);
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.group_long_term_disability);
	}, [setDashboardHeader, handleGetInitialFormDetails, queryGroupNumber]);

	useEffect(() => {
		setPremiumRecalDynamicForm(
			Object.assign(
				{},
				{
					"Premium Recalculation For GLTD (Class 2) Plan": [
						{
							label: "Plan Type",
							name: "plan_type",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleChange(event),
							value: premiumRecalFieldsDetails.plan_type,
							type: "textfield"
						},
						{
							label: "Plan name",
							name: "plan_name",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleChange(event),
							value: premiumRecalFieldsDetails.plan_name,
							type: "textfield"
						},
						{
							label: "Plan Code",
							name: "plan_code",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleChange(event),
							value: premiumRecalFieldsDetails.plan_code,
							type: "textfield"
						},
						{
							label: "Current Year",
							name: "current_year",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleChange(event),
							value: premiumRecalFieldsDetails.current_year,
							type: "textfield"
						},
						// {
						// 	label: "Recalculation Trigger",
						// 	name: "recalculation_trigger",
						// 	onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleChange(event),
						// 	value: premiumRecalFieldsDetails.recalculation_trigger,
						// 	type: "textfield"
						// },
						{
							label: "Last Recalculated By",
							name: "last_recalculated_by",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleChange(event),
							value: premiumRecalFieldsDetails.last_recalculated_by,
							type: "textfield"
						},
						{
							label: "Last Recalculated On",
							name: "last_recalculated_on",
							onChange: (event: React.ChangeEvent<HTMLInputElement>) => handleChange(event),
							value: premiumRecalFieldsDetails.last_recalculated_on,
							type: "textfield"
						}
					]
				}
			)
		);
	}, [isValuesFetched, premiumRecalFieldsDetails, handleChange]);

	return (
		<>
			<div className="census-report-container" id="census-report-container">
				{/* <Suspense fallback={<div />}>
					<SnackbarAPICall snackbarProps={snackbarAPICallProps} />
				</Suspense> */}
				<div className="chip-container" id="chip-container">
					<Chip className="chip-green" label={chipMessage} variant="outlined" />
				</div>
			</div>
			<div>
				<PremiumRecalculationForm
					premiumRecalcDynamicForm={premiumRecalcDynamicForm}
					// handleClearDateField={() => null}
					validation={validation}
					plan_code={premiumRecalFieldsDetails.plan_code}
					plan_name={premiumRecalFieldsDetails.plan_name}
					last_recalculated_on={premiumRecalFieldsDetails.last_recalculated_on}
				/>
			</div>
		</>
	);
};

export default GLTDPremiumRecalculationForm;
